import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useQuoteAddEmployeesPageStore } from 'store/pages/quote/add-employees/pageStore';
import { RouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { QuoteTableManagementPanel } from './QuoteTableManagementPanel';
import { QuoteAddEmployeesTable } from './QuoteAddEmployeesTable';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useQuoteAddEmployeesPageStore();
  const { onComplete, stepCanComplete } = pageStore;

  useEffect(() => {
    void pageStore.flowDelegate.getFlowInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={pageStore.flowDelegate}
      pageId={RouteV2Id.QUOTE_ADD_EMPLOYEES}
      pageHeader={{
        subtitleMaxWidth: '42rem',
      }}
      isPageLoading={pageStore.flowDelegate.isInitialDataLoading}
      pageFooter={{
        onComplete,
        disableCompleteButton: !stepCanComplete,
      }}
    >
      <QuoteTableManagementPanel />
      <QuoteAddEmployeesTable />
    </QuoteFlowLayout>
  );
});
